import { createSelector } from 'reselect';

import { AI_FEATURE_PROPERTY_KEYS } from 'constants/aiFeatures';

import { selectMasterCompanyPropertiesAsObject } from './properties.selectors';

const isPropertyTrue = (properties, key) => properties[key] === 'true';

export const selectIsAiChatEnabled = createSelector(
  [selectMasterCompanyPropertiesAsObject],
  properties => isPropertyTrue(properties, AI_FEATURE_PROPERTY_KEYS.ENABLE_AI_CHAT),
);

export const selectIsAiExpressionExplanationsEnabled = createSelector(
  [selectMasterCompanyPropertiesAsObject],
  properties =>
    isPropertyTrue(properties, AI_FEATURE_PROPERTY_KEYS.ENABLE_AI_EXPRESSION_EXPLANATIONS),
);

export const selectIsAiExpressionGenerationsEnabled = createSelector(
  [selectMasterCompanyPropertiesAsObject],
  properties =>
    isPropertyTrue(properties, AI_FEATURE_PROPERTY_KEYS.ENABLE_AI_EXPRESSION_GENERATIONS),
);
